// utils/description.ts (or inline in your component)

export const renderDescriptionHtml = (post) => {
  const bucket = process.env.REACT_APP_BUCKET_URL || ""
  const html = post?.description || ""
  const images = Array.isArray(post?.images) ? post.images : []
  const documents = Array.isArray(post?.documents) ? post.documents : []

  // Parse the HTML so we can safely manipulate nodes
  const doc = new DOMParser().parseFromString(html, "text/html")

  // 1) Images: replace placeholders + apply styles + wrap if needed
  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src") || ""

    // Replace src="image_1" with the actual URL from post.images[0], etc.
    // const m = src.match(/^image_(\d+)$/)
    // if (m) {
    //   const idx = Number.parseInt(m[1], 10) - 1
    //   if (images[idx]) {
    //     img.setAttribute("src", bucket + images[idx])
    //   }
    // }

    // Move custom 'containerstyle' to the real 'style' on the <img>
    const containerStyle = img.getAttribute("containerstyle") || ""
    if (containerStyle) {
      const existing = img.getAttribute("style") || ""
      const merged = [existing, containerStyle].filter(Boolean).join("; ")
      img.setAttribute("style", merged)
    }

    // If we have a 'wrapperstyle', create a real wrapper <div style="..."> and put the <img> inside it
    const wrapperStyle = img.getAttribute("wrapperstyle") || ""
    img.removeAttribute("containerstyle")
    img.removeAttribute("wrapperstyle")

    if (wrapperStyle) {
      const wrapper = doc.createElement("div")
      wrapper.setAttribute("style", wrapperStyle)

      // Insert wrapper before img, then move img inside wrapper
      const parent = img.parentNode
      if (parent) {
        parent.insertBefore(wrapper, img)
        wrapper.appendChild(img)
      }
    } else {
      // If no wrapperstyle but the img relies on margin auto to align,
      // ensure it sits inside a flex wrapper so margin-left:auto works.
      if (/margin\s*:\s*[^;]*auto/.test(containerStyle)) {
        const wrapper = doc.createElement("div")
        wrapper.setAttribute("style", "display:flex;")
        const parent = img.parentNode
        if (parent) {
          parent.insertBefore(wrapper, img)
          wrapper.appendChild(img)
        }
      }
    }
  })

  // 2) Documents: replace href="doc_1" with actual URL (if you used file placeholders)
  // doc.querySelectorAll('a[href^="doc_"]').forEach((a) => {
  //   const href = a.getAttribute("href") || ""
  //   const m = href.match(/^doc_(\d+)$/)
  //   if (m) {
  //     const idx = Number.parseInt(m[1], 10) - 1
  //     if (documents[idx]) {
  //       a.setAttribute("href", bucket + documents[idx])
  //     }
  //   }
  // })
console.log("doc.body.innerHTML",doc.body.innerHTML)
  return doc.body.innerHTML
}


